'use client';

import { useChat } from '@/hooks/useChatContext';
import { useEffect } from 'react';

export default function InitializeChat({ lang }: { lang: Locale }) {
  const { initializeChat } = useChat();

  useEffect(() => {
    initializeChat(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
